export default "__VITE_ASSET__087ec2a0__"